import { X, Crown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PersonAvatar } from '../shared';
import type { TeamMembershipDto } from '@signalvote/shared';

interface TeamMemberListProps {
  members: TeamMembershipDto[];
  leadUserId: string | null;
  onRemoveMember: (userId: string) => void;
  isRemoving: boolean;
}

export function TeamMemberList({ members, leadUserId, onRemoveMember, isRemoving }: TeamMemberListProps) {
  if (members.length === 0) {
    return (
      <p className="text-sm text-muted-foreground text-center py-4">
        No members yet. Add people to this team.
      </p>
    );
  }

  return (
    <div className="space-y-1">
      {members.map((member) => (
        <div
          key={member.id}
          className="flex items-center justify-between py-2 px-2 rounded-md hover:bg-accent/50 group"
        >
          <div className="flex items-center gap-3 min-w-0">
            <PersonAvatar
              firstName={member.user.firstName}
              lastName={member.user.lastName}
              size="sm"
            />
            <div className="min-w-0">
              <div className="flex items-center gap-1.5">
                <span className="text-sm font-medium truncate">
                  {member.user.firstName} {member.user.lastName}
                </span>
                {member.userId === leadUserId && (
                  <Crown className="h-3 w-3 text-amber-500 shrink-0" />
                )}
              </div>
              <span className="text-xs text-muted-foreground truncate block">
                {member.user.email}
              </span>
            </div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            className="h-7 w-7 p-0 opacity-0 group-hover:opacity-100 transition-opacity shrink-0"
            onClick={() => onRemoveMember(member.userId)}
            disabled={isRemoving}
          >
            <X className="h-4 w-4 text-muted-foreground" />
          </Button>
        </div>
      ))}
    </div>
  );
}
